import request from '../libs/request';

const res = 'ViewColumn';

export default {
  queryByDataViewID(dataViewID) {
    return request({
      url: `api/${res}/query`,
      method: 'post',
      data: {
        dataViewID,
        orderBy: '+OrderNo'
      }
    });
  }
};
